module.exports = __webpack_public_path__ + "static/media/pl-lk-4.9153313f.jpg";